import styled from "styled-components";

const TitleModal = styled.div`
  font-weight: 600;
  font-size: 1.5em;
  width: 100%;
  padding: 10px 0px;
  text-align: center;
`;

export default TitleModal;
